import { graphql, HttpResponse } from 'msw'
import { type EnrollmentHYCSFundSuccessData, type EnrollmentHYCSFundSuccessSubmitOutput } from '../../../../models'

export const getEnrollmentHYCSFundSuccessDataMock: EnrollmentHYCSFundSuccessData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/hycs/fund-success',
}

export const submitEnrollmentHYCSFundSuccessDataMock: EnrollmentHYCSFundSuccessSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/',
}

export const mockGetEnrollmentHYCSFundSuccessData = graphql.mutation('getEnrollmentHYCSFundSuccessData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentHYCSFundSuccessDataMock } })
})

export const mockSubmitEnrollmentHYCSFundSuccessData = graphql.mutation('submitEnrollmentHYCSFundSuccessData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentHYCSFundSuccessDataMock } })
})

export const mockEnrollmentHYCSFundSuccess = [
  mockGetEnrollmentHYCSFundSuccessData,
  mockSubmitEnrollmentHYCSFundSuccessData,
]
